// Tenant self-service billing API (Phase 4). Wraps apiFetch (tenant plane).
import { apiFetch } from './client';

export interface MyPayment {
  id: string;
  method: string | null;
  status: string;
  usdAmount: number | null;
  amount: number | null;
  currency: string;
  createdAt: string;
}

export interface MySubscription {
  enrolled: boolean;
  status: string | null; // 'trialing' | 'active' | 'past_due' | 'canceled' | null
  suspended: boolean;
  trialEndsAt: string | null;
  currentPeriodEnd: string | null;
  daysLeft: number | null;
  seats: number;
  seatPriceUsd: number;
  usd: number;
  payments: MyPayment[];
}

export interface CheckoutResult {
  redirectUrl: string;
  ziinaIntentId: string;
  usd: number;
  totalAed: number;
  fxRate: number;
  seats: number;
  reused: boolean;
}

export function getMySubscription(): Promise<MySubscription> {
  return apiFetch<MySubscription>('/billing/my-subscription');
}

/** Admin-only server-side; starts a Ziina checkout and returns the redirect link. */
export function startCheckout(): Promise<CheckoutResult> {
  return apiFetch<CheckoutResult>('/billing/my-checkout', { method: 'POST' });
}
